import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ThemeToggle } from '@/components/theme-toggle';
import { MobileNav } from '@/components/mobile-nav'; // MobileNav가 실제로 존재한다고 가정하고 유지
import { motion } from 'framer-motion';

export function TermsPage() {
  const navigate = useNavigate();

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.5 }
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-background via-background to-background/80">
      {/* 헤더 */}
      <header className="sticky top-0 z-10 border-b bg-background/80 backdrop-blur-md">
        <div className="container flex h-16 items-center justify-between">
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate(-1)}
              aria-label="뒤로 가기"
              className="mr-2"
            >
              <ArrowLeft className="h-5 w-5" />
              <span className="sr-only">뒤로 가기</span>
            </Button>
            <h1 className="text-xl font-bold">이용약관 및 개인정보 처리방침</h1>
          </div>
          <ThemeToggle />
        </div>
      </header>

      {/* 메인 컨텐츠 */}
      <main className="container flex-1 py-8 pb-24 md:pb-12">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="mx-auto max-w-3xl space-y-8 prose dark:prose-invert"
        >
          <div className="rounded-xl border bg-card/50 p-6 shadow-sm">
            <h2 className="text-2xl font-bold mb-4">이용약관 및 개인정보 처리방침</h2>

            {/* 이용약관 섹션 */}
            <h3 className="text-xl font-semibold mt-6 mb-2">제1장 총칙</h3>
            <p className="mb-4">
              제1조(목적) 이 약관은 DANIEL!ST(이하 "회사")가 제공하는 Instachat 서INSTA LAB스")의 이용 조건 및 절차, 회사와 회원 간의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">제2장 서비스 이용계약</h3>
            <p className="mb-4">
              제2조(이용계약의 성립) 서비스 이용계약은 이용자가 본 약관에 동의하고 회사가 제공하는 양식에 따라 회원가입을 완료함으로써 성립합니다.
            </p>

            {/* 개인정보 처리방침 섹션 */}
            <h2 className="text-2xl font-bold mt-8 mb-4">개인정보 처리방침</h2>
            <p className="mb-4">
              INSTA LAB (DANIEL!ST)은 (이하 '회사'는) 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다. 회사는 개인정보처리방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다. 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">수집하는 개인정보 항목</h3>
            <p className="mb-4">
              회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.<br />
              ο 수집항목: 이름, 로그인ID, 비밀번호, 이메일, 서비스 이용기록, 접속 로그, 접속 IP 정보 등<br />
              ο 개인정보 수집방법: 홈페이지(회원가입)
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">개인정보의 수집 및 이용목적</h3>
            <p className="mb-4">
              회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br />
              ο 서비스 제공에 관한 계약 이행 및 서비스 제공<br />
              ο 회원 관리: 회원제 서비스 이용에 따른 본인확인, 개인 식별, 고지사항 전달<br />
              ο 마케팅 및 광고에 활용: 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계
              ο 대화가 이루어지는 상대방에게 대화 내역 및 조회자 등의 정보를 사실에 기반하여 고지
              
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">개인정보의 보유 및 이용기간</h3>
            <p className="mb-4">
              회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를 지체 없이 파기합니다.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">개인정보의 파기절차 및 방법</h3>
            <p className="mb-4">
              회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.<br />
              ο 파기절차: 회원님이 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져 내부 방침 및 기타 관련 법령에 따라 일정 기간 저장된 후 파기됩니다.<br />
              ο 파기방법: 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">개인정보 제공</h3>
            <p className="mb-4">
              회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<br />
              
              - 이용자들이 사전에 동의한 경우 : 이는 이용자들이 회원가입을 완료하였다는 사실에 근거합니다.<br />
              - 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우 - 이용자들이 상대방의 인스타그램을 연결하여 대화를 시작한 경우 등 - 이용자들이 회원가입을 완료한 경우 등
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">수집한 개인정보의 위탁</h3>
            <p className="mb-4">
              회사는 고객님의 동의 없이 고객님의 정보를 외부 업체에 위탁하지 않습니다. 향후 필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에 대해 고객님에게 통지하고 사전 동의를 받겠습니다.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">이용자 및 법정대리인의 권리와 그 행사방법</h3>
            <p className="mb-4">
              이용자 및 법정 대리인은 언제든지 등록된 자신 혹은 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다. 개인정보 조회 및 수정을 위해서는 '개인정보변경'을, 가입해지를 위해서는 '회원탈퇴'를 클릭하여 본인 확인 절차 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.<br />
              개인정보 오류 정정을 요청하신 경우, 정정이 완료될 때까지 해당 개인정보를 이용 또는 제공하지 않습니다.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</h3>
            <p className="mb-4">
              회사는 쿠키(cookie)'를 운용합니다. 쿠키는 웹사이트 운영에 이용되는 서버가 귀하의 브라우저에 보내는 작은 텍스트 파일로, 귀하의 컴퓨터에 저장됩니다.<br /><br />
              <span className="font-semibold">▶ 쿠키 사용 목적</span><br />
              - 접속 빈도 분석, 이용자 맞춤 서비스 제공<br />
              귀하는 쿠키 설치에 대한 선택권을 가지고 있으며, 브라우저 설정에서 모든 쿠키를 허용하거나, 저장 시 확인하거나, 모두 거부할 수 있습니다.<br /><br />
              <span className="font-semibold">▶ 쿠키 설정 거부 방법</span><br />

            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">개인정보에 관한 민원서비스</h3>
            <p>
              회사는 개인정보 보호와 관련 불만 처리를 위해 아래와 같이 개인정보관리책임자를 지정하고 있습니다.<br /><br />
              <span className="font-semibold">개인정보관리책임자</span><br />
              성명: 임규빈<br />
              
              이메일: daniel1st@daniel1stai.com<br /><br />
              개인정보보호 관련 민원은 개인정보관리책임자에게 신고하실 수 있으며, 신속히 답변드리겠습니다.<br />
              기타 문의:<br />
              1. 개인정보침해신고센터 (privacy.kisa.or.kr / 118)<br />
              2. 정보보호마크인증위원회 (www.eprivacy.or.kr / 02-550-9531~2)<br />
              3. 대검찰청 사이버수사과 (www.spo.go.kr / 1301)<br />
              4. 경찰청 사이버수사국 (ecrm.cyber.go.kr / 182)
            </p>
          </div>

          <div className="flex justify-center pt-4 pb-8">
            <Button onClick={() => navigate(-1)} className="w-40">
              뒤로 가기
            </Button>
          </div>
        </motion.div>
      </main>

      {/* 푸터 */}
      <footer className="container py-6 pb-24 text-center text-sm text-muted-foreground">
        <p>사업자등록번호: 603-17-50971 / 대표자: 임규빈<br />
          다니엘퍼스트 © 2024 INSTA CHAT AI Corp.<br />
          고객센터: danielai@daniel1stai.com</p>
      </footer>

      {/* 모바일 네비게이션 */}
      <MobileNav />
    </div>
  );
}